import type { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import { ISupplier_Type } from '@bridebook/models/source/models/Suppliers.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import {
  type SupplierBucketSettingResult,
  resolveSupplierBucketSetting,
} from '../resolve-supplier-bucket-setting';

/**
 * Hook to get a bucket setting, supporting both type-filtered and non-type-filtered settings.
 *
 * @param settingName The setting key to retrieve.
 * @param type The supplier type (required for type-filtered settings).
 * @param market The market instance (from useMarket() or similar).
 * @param tier The supplier's premium tier.
 * @returns An object with isEnabled, isUnlocked, minimumTierRequired, and setting (null if not enabled).
 */
export function useSupplierBucketSetting<K extends keyof IBucket['settings']>(
  settingName: K,
  type: ISupplier_Type | undefined,
  market?: Market,
  tier: PremiumTiers | undefined = PremiumTiers.Unverified,
): SupplierBucketSettingResult<K> {
  return resolveSupplierBucketSetting(settingName, type, market, tier);
}
